import React,{useState,useEffect} from 'react'
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faKey } from '@fortawesome/free-solid-svg-icons';
import DeleteButton from '../../../../components/panelcontrols/paneltablebuttons/deletebutton'
import EditButton from '../../../../components/panelcontrols/paneltablebuttons/editbutton'
import Functions from '../functions'

const Index = ({List,setList,setSelectedEmployee,setShowEdit,setShowAccess,toast}) => {
  // Only a lab owner may grant logins - the API rejects everyone else - so the button is hidden
  // rather than shown and then failing with a 401. An employee granted `entries.employees` can
  // manage staff records but never their access.
  const currentUser = JSON.parse(localStorage.getItem("user-info"));
  const canManageAccess = currentUser && currentUser.role === 'labadmin';
  const [filterList,setfilterList] = useState(List);
  function filterFunction(value){
    if(value === ""){
      setfilterList(List);
    }
    else{
      const filtedList = List.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setfilterList(filtedList);
    }
  }
  useEffect(()=>{
      setfilterList(List);
  },[List])
  return (
    <div className='user_table_wrapper'>
      <div className='user_table_search'>
        <input onChange={(e)=>{filterFunction(e.target.value);}}/>
        <div className='user_table_search_icon'>
          <FontAwesomeIcon icon={faSearch}/>
        </div>
      </div>
      <div className='user_table_container'>
        <div className='_table'>
          <div className='_thead'>
            <div className='_tr'>
              {/* Widths re-tuned to make room for Login; they must still total 100. */}
              <div className='_th' style={{width:"15%"}}>Name</div>
              <div className='_th' style={{width:"13%"}}>Designation</div>
              <div className='_th' style={{width:"9%"}}>Salary</div>
              <div className='_th' style={{width:"9%"}}>Status</div>
              <div className='_th' style={{width:"13%"}}>Contact</div>
              <div className='_th' style={{width:"13%"}}>Cnic</div>
              <div className='_th' style={{width:"13%"}}>Login</div>
              <div className='_th' style={{width:"15%"}}></div>
            </div>
          </div>
          <div className='_tbody'>
            {filterList.length > 0 &&
              filterList.map((item,index)=>{
                return(
                  <div className='_tr' key={index}>
                    <div className='_td' style={{width:"15%"}}>{item.name}</div>
                    <div className='_td' style={{width:"13%"}}>{item.designation}</div>
                    <div className='_td' style={{width:"9%"}}>{item.salary}</div>
                    <div className='_td' style={{width:"9%"}}>{item.status}</div>
                    <div className='_td' style={{width:"13%"}}>{item.contact}</div>
                    <div className='_td' style={{width:"13%"}}>{item.cnic}</div>
                    <div className='_td' style={{width:"13%"}}>
                      {item.hasLogin
                        ? <span className='labadmin_employee_login_yes'>{item.loginusername}</span>
                        : <span className='labadmin_employee_login_no'>No login</span>}
                    </div>
                    <div className='_td' style={{width:"15%",display:"flex", justifyContent:"space-evenly"}}>
                      {canManageAccess &&
                        <button
                          className='labadmin_employee_access_btn'
                          title={item.hasLogin ? 'Edit login & access' : 'Give this employee a login'}
                          onClick={()=>{
                            setSelectedEmployee(item);
                            setShowAccess(true);
                          }}>
                          <FontAwesomeIcon icon={faKey}/>
                        </button>
                      }
                      <EditButton Action={()=>{
                        setSelectedEmployee(item);
                        setShowEdit(true);
                      }}/>
                      <DeleteButton Action={()=>{
                        const confermation = window.confirm('Are you sure you want to delete this doctor?');
                        if(!confermation){
                          return;
                        }
                        const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
                        Functions.Delete(item.id,setList,toast,toastid)
                      }}/>
                    </div>
                  </div>
                )
              })
            }
            {filterList.length <= 0 &&
              <div className='table_nodata'>
                <p>No data available</p>
              </div>
            }
          </div>
        </div>
      </div>      
    </div>
  )
}

export default Index
